module.exports = __webpack_public_path__ + "static/media/AB_K18_11.7f86dc10.jpg";